<app-card [shadow]="true">
  <div class="full-height-stack">

    <!-- Title and separator -->
    <app-card-title size="large">
        <span appPageTitle>
          {{ 'initialization.title' | translate }}
        </span>
    </app-card-title>
    <app-stack-separator></app-stack-separator>

    <!-- Spinner & message -->
    <div class="flex-center flex-stretch pad-top-lg pad-bottom">
      <app-spinner></app-spinner>
    </div>
    <p class="text-center">
      {{ 'initialization.message' | translate }}
    </p>
  </div>
</app-card>
